<template>
  <div class="order-box">
    <nav-index :title="title"/>
    <div class="order-card-block">
      <div v-if="showEmyptyImg && !orderLoading">
          <div class="none-list">
              <img src="../../assets/images/none.svg" alt="">
              <div class="none">您还没有订单喔~</div>
          </div>
      </div>
      <div v-else>
        <BillsDetailCard v-for="(order,i) in orderInfo" :key="i" :orderInfo="order" :logoUrl="logoUrl" @pay="openPayment"/>
      </div>
    </div>
  </div>
</template>

<script>
import BillsDetailCard from '../../components/card/BillsDetailCard.vue'
import NavIndex from '../../components/nav/index.vue'
import { queryOrderByOidList } from '@/api/api'
// import {Toast} from 'vant'
import { getopenIdByCode } from '@/utils/index';
const seo = require('../../../config/index')

export default {
name: 'BillsDetail',
components: {
  NavIndex,
  BillsDetailCard,
},
created(){
  getopenIdByCode()
  this.getData()
},
mounted(){
},
destroyed(){
},
data:()=>{
  return {
    showEmyptyImg: false,
    orderInfo:[],
    orderLoading: false,
    oidList:[],
    title:'白单详情',
    logoUrl: seo.config.logo,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : {}
  }
},
methods:{
  getData(){
    this.showEmyptyImg = false
    this.orderLoading = true
    if(this.$route.query.oidList){
      this.oidList = JSON.parse(this.$route.query.oidList)
    }
    queryOrderByOidList({ oidList: this.oidList }).then(res=>{
        this.orderInfo = []
        let resData = res.data.data
        if(resData.length > 0){
          resData.forEach((item)=>{
            let temp = {}
            temp.oid = item.oid
            temp.lists = item.lists
            temp.totalPrice = item.total_price
            temp.discountPrice = item.discount
            temp.finalPayPrice = item.finally_price
            temp.createAt = item.createdAt
            temp.status = item.order_status
            temp.waybill = item.waybill
            temp.phoneNum = item.phone_num
            temp.shop = item.shop
            this.orderInfo.push(temp)
          })
        } else {
          this.showEmyptyImg = true
        }
        this.orderLoading = false
    })
  },
  openPayment(){
    // this.$router.push({ path:'/order-desc', query:{ oid: oid, tabId: this.tabId } })
  },
},
}
</script>

<style scoped lang="scss">
.order-box {
  min-height: 100vh;
  .order-card-block {
    padding: 55px 0 10px;
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
}
.header {
  display: flex;
  align-items: center;
  margin: 10px 10px 0 10px;
  input {
      width: 100%;
      border-radius: 5px;
      height: 40px;
      border: 1px solid #eee;
      padding-left: 15px;
      box-sizing: border-box;
      -webkit-appearance: none;
  }
  div {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      margin-top: 10px;
      width: 40px;
      min-width: 48px;
      padding-right: 10px;
  }
  .searchImg {
      width: 20px;
      position: absolute;
      right: 20px;
  }
}
.none-list {
  margin: 60px auto 20px;
  width: 100%;
  max-width: 625px;
  .none {
      margin: 10px 0 0;
      color: #969699;
  }
  img {
      min-height: 142px;
  }
}
.load-more {
  text-align: center;
  color: #969699;
  padding: 0px 0 5px 0;
  font-size: 14px;
}
</style>